import './LegalClosingSection.css';

const COPY = {
  privacy: {
    body:
      'If you have questions or require clarification regarding any aspect of this Privacy Policy, we encourage you to connect with us directly. Our intent is to maintain transparency, clarity, and responsible handling of your information throughout every engagement.',
  },
  terms: {
    body:
      'If you have questions or require clarification regarding any aspect of these terms, we encourage you to connect with us directly. Our intent is to maintain transparency, clarity, and responsible advisory throughout every engagement.',
  },
};

export default function LegalClosingSection({ variant = 'privacy' }) {
  const { body } = COPY[variant] || COPY.privacy;

  return (
    <section className="legal-closing" aria-labelledby="legal-closing-title">
      <h2 id="legal-closing-title" className="legal-closing-title">
        Questions or Clarifications?
      </h2>
      <p className="legal-closing-body">{body}</p>
      <hr className="legal-closing-rule" />
      <p className="legal-closing-regards">Warm regards,</p>
      <div className="legal-closing-card">
        <p className="legal-closing-name">Pranjul Mishra</p>
        <hr className="legal-closing-card-rule" />
        <p className="legal-closing-role">Founder and Consultant</p>
        <p className="legal-closing-company">
          <span className="legal-closing-brand">Landmarks Construction</span>
        </p>
      </div>
    </section>
  );
}
